import Const from 'const';
import {combineReducers} from 'redux';

interface LineupGeneratorSettingsInterface {
    getGeneratorType(sportConfig): string;
    getGeneratorVersion(sportConfig): string;
    isBackendGeneratorType(sportConfig): boolean;
    isShowPlayersExposureWhileOptimizedUsed(): boolean;
    isRelaxBuildRulesUsed(): boolean;
}

interface LineupGeneratorSettingsStructure {
    readonly generatorType?: string;
    readonly showPlayersExposureWhileOptimized: boolean;
    readonly relaxBuildRules: boolean;
}

class LineupGeneratorSettings implements LineupGeneratorSettingsInterface {
    private readonly generatorTypesMap = Const.GENERATOR_TYPE_DEFAULT_VALUES;
    constructor(public readonly settings: LineupGeneratorSettingsStructure) {}
    getGeneratorType(sportConfig): string {
        if (this.settings.generatorType !== undefined) {
            return this.settings.generatorType;
        }

        const sport = sportConfig.getSport() || '';
        const gameType = sportConfig.getGameType() || '';

        return sport in this.generatorTypesMap && gameType in this.generatorTypesMap[sport]
            ? this.generatorTypesMap[sport][gameType]
            : Const.GENERATOR_TYPE_COMMON_DEFAULT_VALUES;
    }
    getGeneratorVersion(sportConfig): string {
        const generatorType = this.getGeneratorType(sportConfig);

        if (generatorType === Const.GENERATOR_TYPE_BACKEND_V1) {
            return '1';
        } else if (generatorType === Const.GENERATOR_TYPE_BACKEND_V2) {
            return '2';
        } else if (generatorType === Const.GENERATOR_TYPE_BACKEND_V3) {
            return '3';
        }

        return '0';
    }
    isBackendGeneratorType(sportConfig): boolean {
        return [
            Const.GENERATOR_TYPE_BACKEND_V1,
            Const.GENERATOR_TYPE_BACKEND_V2,
            Const.GENERATOR_TYPE_BACKEND_V3,
        ].includes(this.getGeneratorType(sportConfig));
    }
    isShowPlayersExposureWhileOptimizedUsed(): boolean {
        return this.settings.showPlayersExposureWhileOptimized;
    }
    isRelaxBuildRulesUsed(): boolean {
        return this.settings.relaxBuildRules;
    }
}

const defaultState: LineupGeneratorSettingsStructure = {
    showPlayersExposureWhileOptimized: false,
    relaxBuildRules: false,
};

const lineupGeneratorSettings = new LineupGeneratorSettings(defaultState);

export function settings(state = lineupGeneratorSettings, action) {
    if (action.type === Const.SET_GENERATOR_TYPE) {
        state = new LineupGeneratorSettings({
            ...state.settings,
            generatorType: action.generatorType,
        });
    } else if (action.type === Const.SET_SHOW_PLAYERS_EXPOSURE_WHILE_OPTIMIZED) {
        state = new LineupGeneratorSettings({
            ...state.settings,
            showPlayersExposureWhileOptimized: action.value,
        });
    } else if (action.type === Const.SET_RELAX_BUILD_RULES) {
        state = new LineupGeneratorSettings({
            ...state.settings,
            relaxBuildRules: action.value,
        });
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = new LineupGeneratorSettings(defaultState);
    }

    return state;
}

const reducers = {
    settings,
};

export default combineReducers(reducers);
